<template>
    <pendo-multiselect
        class="fact-select"
        :value="value"
        :options="options"
        :append-to-body="false"
        :extra-label-width="60"
        :allow-empty="false"
        value-key="id"
        :disabled="readOnly"
        full-width
        preselect-first
        label-key="name"
        :invalid="checkValidRule && !valid"
        @select="onOptionSelect">
        <template #selectedLabel="{ option }">
            <pendo-icon-option :option="option" />
        </template>
        <template #option="{ option }">
            <pendo-icon-option :option="option" />
        </template>
    </pendo-multiselect>
</template>

<script>
import { PendoMultiselect, PendoIconOption } from '@pendo/components';

export default {
    name: 'FactSelect',
    components: {
        PendoMultiselect,
        PendoIconOption,
    },
    props: {
        value: {
            type: Object,
            default: null,
        },
        options: {
            type: Array,
            default: () => [],
        },
        checkValidRule: {
            type: Boolean,
            default: false,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['input'],
    computed: {
        valid () {
            return this.value != null && this.value !== false;
        },
    },
    methods: {
        onOptionSelect (option) {
            this.$emit('input', { field: ['fact', 'kind', 'schema'], value: option });
        },
    },
};
</script>
